import { createReducer } from '../../store.model';

import { ListMeetings } from './state/list-meetings.action';
import { listMeetingsReducer } from './state/list-meetings.reducer';
import { ReceiveMeetings } from './state/receive-meetings.action';
import { receiveMeetingsReducer } from './state/receive-meetings.reducer';
import { Reload, ReloadResult } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
import { SelectDateRange } from './state/select-date-range.action';
import { selectDateRangeReducer } from './state/select-date-range.reducer';
import { SelectUser } from './state/select-user.action';
import { selectUserReducer } from './state/select-user.reducer';
import { ActionType } from './transcript-import-dialog.action';
import {
    defaultState,
    TranscriptImportDialogState,
} from './transcript-import-dialog.state';

const { builder, reducer } = createReducer<
    ActionType,
    TranscriptImportDialogState
>(defaultState());

builder.add<Reload>(ActionType.TC__TI__RELOAD, reloadReducer);
builder.add<ReloadResult>(
    ActionType.TC__TI__RELOAD_RESULT,
    reloadResultReducer,
);

builder.add<SelectUser>(ActionType.TC__TI__SELECT_USER, selectUserReducer);

builder.add<SelectDateRange>(
    ActionType.TC__TI__SELECT_DATE_RANGE,
    selectDateRangeReducer,
);

builder.add<ListMeetings>(
    ActionType.TC__TI__LIST_MEETINGS,
    listMeetingsReducer,
);

builder.add<ReceiveMeetings>(
    ActionType.TC__TI__RECEIVE_MEETINGS,
    receiveMeetingsReducer,
);

export const transcriptImportDialogReducer = reducer;
